import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import Spinner from '../common/spinner';
import GenericInput from "../common/input/GenericInput";
import DataComponent from "../common/DataComponent";
import ResetPasswordConfirmation from "./ResetPasswordConfirmation";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

export const initialState = {
    fields: {
        newPassword: "",
        confirmPassword: ""
    },
    errors: {},
    hasCapital: false, hasLower: false, hasSpecial: false, hasReqLength: false, passwordMismatch: true,
    showErrors: false
};

/**
* Container component for the Reset Password page.
*
 */
class ResetPassword extends DataComponent {

    constructor(props) {
        super(props);
        const { location } = props;
        this.params = location.search ? queryString.parse(location.search)
            : location.searchParms ? queryString.parse(location.searchParms) : null;
        this.state = Tools.deepCopy(initialState);
        this.resetPassword = this.resetPassword.bind(this);
        this.validateInputs = this.validateInputs.bind(this);
        this.handleNewPasswordChange = this.handlePasswordChange.bind(this, 'newPassword');
        this.handleConfirmPasswordChange = this.handlePasswordChange.bind(this, 'confirmPassword');
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.ResetPassword.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    handlePasswordChange(field, e) {
        if (e) {
            let fields = this.state.fields;
            fields[field] = e.target.value;
            this.setState({ fields }, () => { this.validateInputs(); });
        }

        window.componentChanged = true;

        return true;
    }

    validateInputs() {
        const { newPassword, confirmPassword } = this.state.fields;
        let errors = {};

        if (!Tools.isValidPassword(newPassword)) {
            errors.newPassword = "You must enter a valid password.";
        }

        if (!Tools.isValidPassword(confirmPassword)) {
            errors.confirmPassword = "You must enter a valid password.";
        }

        if (confirmPassword.length < 1) {
            errors.confirmPasswordEmpty = true;
        }
        else if (newPassword !== confirmPassword) {
            errors.passwordMismatch = true;
        }

        const passwordMismatch = errors.passwordMismatch;
        const hasCapital = /([A-Z]+)/g.test(newPassword);
        const hasLower = /([a-z]+)/g.test(newPassword);
        const hasSpecial = /[!@#$ %^&* (),.? ":{}|<>/[`~|\]\\0-9]/g.test(newPassword);
        const hasReqLength = newPassword.length > 7;

        this.setState({ errors, hasCapital, hasLower, hasSpecial, hasReqLength, passwordMismatch });
        return Tools.isObjectEmpty(errors) && hasCapital && hasLower && hasSpecial && hasReqLength;
    }

    resetPassword(event) {
        event.preventDefault();
        if (!this.validateInputs()) {
            this.setState({ showErrors: true });
            return false;
        }

        if (this.params && this.params.token && this.params.userId) {
            this.props.resetPassword(this.params.token, this.params.userId, this.state.fields["newPassword"]);
            logUI("MBHWeb.Settings.ResetPassword", new Date(), Tools.getURLPath());
        }
    }

    render() {
        const isClientSide = typeof window !== 'undefined';
        const isValid = this.params && this.params.token && this.params.userId;
        const redirect = this.params && this.params.redirect;
        const { inProcess, success, failure } = this.props.resetPasswordAction;
        const { errors, showErrors, hasCapital, hasLower, hasSpecial, hasReqLength, passwordMismatch } = this.state;
        window.componentChanged = false;

        return (
            <div className="container-fluid body-logged-out reset-pw-container">
                <div className={"row " + (showErrors ? " form-submitted " : "")}>
                    <div className="col-12 page-form-sm">
                        <div className="row">
                            <div className="col-12 text-center">
                                <Link to="/login">
                                    <img alt="MyBSWHealth logo" src="/images/mybswhlogo.png" className="img-fluid" />
                                </Link>
                            </div>
                        </div>

                        {!success
                            ? <div>
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <h1 className="page-heading form-heading">Reset Your Password</h1>
                                        {/*<div className="form-sub-heading">Reset Password from Link</div>*/}
                                        <div className="col-12">
                                            {showErrors && passwordMismatch &&
                                                <div className="error-msg">Password confirmation doesn’t match.</div>
                                            }
                                        </div>

                                        {!isValid &&
                                            <div className="col-12">
                                                <div className="error-msg">Sorry, we are unable to proceed because the URL is not valid.</div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="row align-items-end">
                                    {failure &&
                                        <div className="col-12 text-center error-msg">
                                            <div>{failure.message}</div>
                                        </div>
                                    }
                                    {success &&
                                        <div className="col-12 text-center success-msg">
                                            <div>{success.message}</div>
                                        </div>
                                    }
                                </div>

                                <div className="row" >
                                    <div className="col-12 form-group">
                                        <GenericInput placeholder="New Password"
                                            value={this.state.fields["newPassword"]} name="newPassword"
                                            type="password"
                                            onChange={this.handleNewPasswordChange}
                                            onBlur={this.validateInputs}
                                            className={showErrors && errors.newPassword ? " input-invalid" : (Tools.isValidPassword(this.state.fields["newPassword"]) ? " input-mismatch-password" : "")}
                                            showClearBtn
                                            showEye
                                        />
                                        {showErrors && <div className="input-error-msg">{errors.newPassword}</div>}
                                    </div>
                                    <div className="col-12 form-group">
                                        <GenericInput placeholder="Confirm Password"
                                            className={showErrors && errors && errors.confirmPassword ? " input-invalid" : (errors && errors.passwordMismatch !== undefined && !errors.passwordMismatch ? " input-mismatch-password" : (errors && errors.passwordMismatch ? " input-invalid" : !errors.confirmPassword && !passwordMismatch ? "input-match-password" : ""))}
                                            value={this.state.fields["confirmPassword"]} name="confirmPassword"
                                            type="password"
                                            onChange={this.handleConfirmPasswordChange}
                                            onBlur={this.validateInputs}
                                            showClearBtn
                                            showEye
                                        />
                                        <span className="password-matches">
                                            {!errors.confirmPassword && !passwordMismatch && <>Password matches</>}
                                        </span>
                                        {showErrors && <div className="input-error-msg">{errors && errors.confirmPassword}</div>}
                                    </div>


                                    {!inProcess
                                        ? <React.Fragment>
                                            <div className="col-12 form-group text-center">
                                                <input className="btn btn-primary" type="submit" value="Reset" disabled={!isClientSide || !isValid} onClick={this.resetPassword} />
                                            </div>
                                            <div className="col-12">
                                                <ul id="password-validator">
                                                    <li id="lowercase-check" className={hasLower ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">One lowercase character</div></li>
                                                    <li id="uppercase-check" className={hasCapital ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">One uppercase character</div></li>
                                                    <li id="character-check" className={hasSpecial ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">One number or special character</div></li>
                                                    <li id="length-check" className={hasReqLength ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">At least 8 characters long</div></li>
                                                </ul>
                                            </div>
                                        </React.Fragment>
                                        : <Spinner />
                                    }
                                </div>
                            </div>
                            : <ResetPasswordConfirmation redirect={redirect} careGiverUrl={this.props.careGiverUrl} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        resetPasswordAction: state.header.resetPassword,
        careGiverUrl: state.session.serverData.careGiverUrl
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetPassword: (token, userId, password) => dispatch({ type: types.RESET_PASSWORD_START, token, userId, password })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);